var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.$props.opened
    ? _c(
        "div",
        { staticClass: "tooltip" },
        [
          _vm._t("default"),
          _c(
            "svg",
            {
              staticClass: "tooltip__arrow",
              attrs: {
                width: "29",
                height: "16",
                viewBox: "0 0 29 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", { attrs: { d: "M2 16L28 2V16H2Z", fill: "white" } }),
              _c("path", {
                attrs: {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M29 0V16H27V3.34843L3.5 16H0L29 0Z",
                  fill: "black",
                },
              }),
            ]
          ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }